module.exports = __webpack_public_path__ + "static/details-10-05ab6f7bfca682799576170cdf97ad2b.jpg";